import React, { useContext, useState,  useCallback } from "react";
import { UserContext } from "UserContext";
import {
  FormControlLabel,
  Grid,
  RadioGroup,
  Radio,
  makeStyles,
} from "@material-ui/core";
import { fetchReport, saveReportResponse } from "fetchUtils";
import ReportsCard from "./ReportsCard";
import OrganizationReportsPickerCard from "./OrganizationReportsPickerCard";
import LoadingButton from "./LoadingButton";

const getIapSelectReportUrl = (props) =>
  `${process.env.REACT_APP_API_BASE_URL}/reports/iap-select/report.csv`;

const getOrganizationIapSelectReportUrl = (props) =>
  `${process.env.REACT_APP_API_BASE_URL}/reports/iap-select/report.csv?org-id=${props.selectedOrganization}`;


const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.secondary.light,
    height: "100%",
    overflowX: "hidden",
  },
  item: {
    flexGrow: 1,
    maxWidth: 600,
    minWidth: 504,
  },
  card: {
    position: "relative",
    overflow: "hidden",
  },
  exportButton: {
    width: 120,
    height: 40,
    marginBottom: 15,
    float: "right",
    right: 15,
  },
  radioGroup: {
    justifyContent: "space-around",
    marginBottom: 15,
  },
}));

const initialState = {
  showLoading: false,
  selectedOrganization: "",
  inventoryGroup: "all",
};

const IapSelectReport = () => {
  const classes = useStyles();
  const { token, user } = useContext(UserContext);
  const [state, setState] = useState(initialState);

  const handleStateChange = (name) => (value) => {
    setState((s) => ({ ...s, [name]: value }));
  };

  const handleSelectedOrganization = useCallback((value) => {
    handleStateChange("selectedOrganization")(value);
  }, []);

  const exportReport = (props) => {
    handleStateChange("showLoading")(true);

    const url =
      props.inventoryGroup === "organization"
        ? getOrganizationIapSelectReportUrl(props)
        : getIapSelectReportUrl(props);

    fetchReport(url, props.token)
      .then((response) => saveReportResponse(response, "iap-select-report.csv"))
      .finally(() => handleStateChange("showLoading")(false));
  };

  return (
    <div>
      <Grid item className={classes.item}>
          <div>
            <ReportsCard cardLabel="REPORT FILTERING" className={classes.card}>
              <RadioGroup
                row
                className={classes.radioGroup}
                value={state.inventoryGroup}
                onChange={(e) =>
                  handleStateChange("inventoryGroup")(e.target.value)
                }
              >
                <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="All"
                />
                <FormControlLabel
                  value="organization"
                  control={<Radio />}
                  label="Organization"
                />
              </RadioGroup>
              {state.inventoryGroup === "all" && (
                  <LoadingButton
                      variant="contained"
                      disableElevation
                      className={classes.exportButton}
                      onClick={() => exportReport({ token, ...state })}
                      // disabled={props.disableExport}
                      showLoading={state.showLoading}
                  >
                    EXPORT
                  </LoadingButton>
              )}
            </ReportsCard>
            <br />
            {state.inventoryGroup === "organization" && (
              <OrganizationReportsPickerCard
                organizations={user.organizations}
                onOrganizationChange={handleSelectedOrganization}
              >
                <LoadingButton
                  variant="contained"
                  disableElevation
                  className={classes.exportButton}
                  onClick={() => exportReport({ token, ...state })}
                  // disabled={props.disableExport}
                  showLoading={state.showLoading}
                >
                  EXPORT
                </LoadingButton>
              </OrganizationReportsPickerCard>
            )}
          </div>
      </Grid>
    </div>
  );
};

export default IapSelectReport;
